// ---------------------------------------------- modules import
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FirebaseReducer, isEmpty, isLoaded } from "react-redux-firebase";

import { AppState } from "../../store/rootReducer";
import { thunkLogin } from "../../store/auth/thunkActions";
import { IUserData } from "../../store/firebase/common";
import ValidationHelper, {
  pattern
} from "../../store/helpers/validationHelper";

// ---------------------------------------------- custom hooks
export const useAuth = () => {
  const dispatch = useDispatch();

  // ---------------------------------------------- redux connect
  const auth = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).auth
  );
  const profile = useSelector(
    (state: AppState) =>
      (state.firebase as FirebaseReducer.Reducer<
        Record<string, Record<string | number, string | number>>,
        IUserData
      >).profile
  );
  const error = useSelector((state: AppState) => state.auth.error);

  // ---------------------------------------------- local state
  const [areLoaded, setAreLoaded] = useState(
    isLoaded(auth) && isLoaded(profile)
  );
  const [isEmptied, setIsEmptied] = useState(isEmpty(auth) || isEmpty(profile));
  const [login, setLogin] = useState({
    email: "",
    password: ""
  });

  const isAuthValid = () =>
    ValidationHelper.validate(login.email, pattern.login.email) &&
    ValidationHelper.validate(login.password, pattern.login.password);

  // ---------------------------------------------- handlers
  const handleChange = (prop: string, value: string) =>
    setLogin({
      ...login,
      [prop]: value
    });

  const handleLogin = () => dispatch(thunkLogin(login.email, login.password));

  // ---------------------------------------------- effects
  useEffect(() => {
    setAreLoaded(isLoaded(auth) && isLoaded(profile));
    setIsEmptied(isEmpty(auth) || isEmpty(profile));
  }, [auth, profile]);

  // ---------------------------------------------- return value
  return {
    error,
    areLoaded,
    isEmptied,
    isAuthValid,
    onChange: handleChange,
    onLogin: handleLogin
  };
};
